import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  DYNAMIC_CONTENTS_LIST,
  DYNAMIC_CONTENT_VIEW,
  DYNAMIC_CONTENT_ADD,
  DYNAMIC_CONTENT_EDIT,
} from './type';

const buildListQuery = (page = 1, filters = {}) => {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('pageSize', String(filters.pageSize || 15));

  if (filters.content_type) params.set('content_type', filters.content_type);
  if (filters.target_type) params.set('target_type', filters.target_type);
  if (filters.status !== undefined && filters.status !== '' && filters.status !== null) {
    params.set('status', String(filters.status));
  }
  if (filters.project_id !== undefined && filters.project_id !== '' && filters.project_id != null) {
    params.set('project_id', String(filters.project_id).trim());
  }

  return params.toString();
};

export const getDynamicContentsList = (page = 1, filters = {}) => async (dispatch) => {
  dispatch({ type: DYNAMIC_CONTENTS_LIST, payload: { contents: [], pagination: {} } });

  const query = buildListQuery(page, filters);
  const res = await callWebService(callTypes.get, '', `${Config.dynamicContents.list}?${query}`);

  if (res?.data?.status === 0) {
    dispatch({
      type: DYNAMIC_CONTENTS_LIST,
      payload: res.data.data || { contents: [], pagination: {} },
    });
    return res.data;
  }
  return res;
};

export const getDynamicContentView = (id) => async (dispatch) => {
  dispatch({ type: DYNAMIC_CONTENT_VIEW, payload: null });

  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.dynamicContents.view}?id=${id}`
  );

  if (res?.data?.status === 0) {
    dispatch({
      type: DYNAMIC_CONTENT_VIEW,
      payload: res.data.data?.content || null,
    });
    return res.data;
  }
  return res;
};

export const addDynamicContent = (payload) => async (dispatch) => {
  try {
    const res = await callWebService(callTypes.post, payload, Config.dynamicContents.add);
    if (res?.data?.status === 0) {
      dispatch({ type: DYNAMIC_CONTENT_ADD, payload: res.data });
      return res.data;
    }
    return res?.data || res;
  } catch (error) {
    return error;
  }
};

export const updateDynamicContent = (payload) => async (dispatch) => {
  try {
    const res = await callWebService(callTypes.post, payload, Config.dynamicContents.edit);
    if (res?.data?.status === 0) {
      dispatch({ type: DYNAMIC_CONTENT_EDIT, payload: res.data });
      return res.data;
    }
    return res?.data || res;
  } catch (error) {
    return error;
  }
};

export const deactivateDynamicContent = (id) => async (dispatch) => {
  try {
    const res = await callWebService(
      callTypes.post,
      { id: Number(id), status: 0 },
      Config.dynamicContents.edit
    );
    if (res?.data?.status === 0) {
      dispatch({ type: DYNAMIC_CONTENT_EDIT, payload: res.data });
      return res.data;
    }
    return res?.data || res;
  } catch (error) {
    return error;
  }
};
